import { useState } from 'react'
import InputField from '../../components/form-input/InputField'
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { login2FASchema } from '../../models/schema/auth';
import { notify } from '../../common/notificationService';
import authSvc from '../../services/api/auth';
import { removeCookies, setCookiesUser } from '../../utils/configuration';
import { LoaderCircle } from 'lucide-react';

type Props = {
    dataFormLogin: {
        email: string;
        password: string;
    }
}
const Login2FA = ({ dataFormLogin }: Props) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onBlur",
        resolver: yupResolver(login2FASchema),
    });
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = async (data: { verifyCode: string }) => {
        if (!data) return;
        setIsLoading(true);
        try {
            const res = await authSvc.login2FA({ ...dataFormLogin, ...data, returnUrl: '/' });
            if (res && res.content) {
                setCookiesUser(res.content);
                removeCookies("isShowDialog");
                removeCookies("isLockScreen");
                window.location.replace(res.content.returnUrl || '/');
            } else {
                notify('Xác thực thất bại', 'Vui lòng kiểm tra lại thông tin xác thực', 'danger');
            }
        }
        catch (e: any) {
            notify('Xác thực thất bại', 'Vui lòng kiểm tra lại thông tin xác thực', 'danger');
        } finally {
            setIsLoading(false);
        }
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)} className='min-w-[400px]'>
            <p className='my-2 text-[rgba(0, 0, 0, 0.6)]'>Tài khoản của bạn đang được bảo vệ. Vui lòng nhập mã xác thực vào ô dưới đây</p>
            <InputField
                name="verifyCode"
                register={register}
                error={errors.verifyCode}
            />
            <div className="flex justify-end gap-1 my-2">
                <button
                    type="submit"
                    className="w-[100px] flex justify-center py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    disabled={isLoading}
                >
                    {isLoading ? <LoaderCircle className="animate-spin mr-2" /> : "Login"}
                </button>
            </div>
        </form>
    )
}

export default Login2FA